import { styled } from "@mui/system";
import { colors } from "../../../utils";

export const MainContainer = styled("div")({
  height: "10vh",
  backgroundColor: colors.background,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  boxShadow: "0 4px 7px #00000014",
});

export const IconWrapper = styled("div")(() => ({
  height: "40px",
  width: "40px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  borderRadius: "4px",
  padding: "8px",
  margin: "2px 10px",
  transition: "box-shadow 0.2s ease",

  "&:active": {
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
  },

  "&:hover": {
    backgroundColor: "#dee2e66e",
  },
}));

export const Icon = styled("img")({
  width: "100%",
  height: "100%",
});

export const FlexContainer = styled("div")({
  display: "flex",
  justifyContent: "space-evenly",
  alignItems: "center",
  margin: "0px 20px",
});

export const LogoContainer = styled("div")({
  marginRight: "1vw",
  cursor: "pointer",
});

export const AddWheelButton = styled("div")({
  cursor: "pointer",
});

export const CenterContainer = styled("div")({
  paddingRight: "10vw",
});

export const Beta = styled("img")({
  width: 70,
  height: 32,
  marginRight: 10,
  cursor: "pointer",
});
